import { assign } from "lodash-es";
import {
    ComparatorPicker,
    ComparatorPickerBuilder,
    ComparatorPickerType,
    ComparisonOperator,
    Field,
    FieldType,
} from "../../vforms-model";
import { FileUploaderEditorComponent } from "./file-uploader-editor.component";
import { FileUploaderComponent } from "./file-uploader.component";
import { ComparisonExpression } from "../../expression-settings/model";

export const ALLOWED_TYPES = [
    ".pdf",
    ".png",
    ".jpg",
    ".jpeg",
    ".webp",
    ".docx",
    ".html",
    ".txt",
    ".mp4",
    ".avi",
    ".mov",
    ".ppt",
    ".m4a",
    ".mp3",
    ".wav",
    ".xlsx",
    ".heic",
    ".csv",
    ".rtf",
];

export class FileUploaderType extends FieldType {
    static Id = "files";

    constructor() {
        super();
        this.id = FileUploaderType.Id;
        this.icon = "mat_outline:upload_file";
        this.previewComponent = FileUploaderComponent;
        this.editorComponent = FileUploaderEditorComponent;
    }

    createField(): Field {
        return new FileUploaderField(this);
    }

    evaluate(expression: ComparisonExpression, value: any): boolean {
        if (expression.operator === ComparisonOperator.Empty && (!value || value.length === 0)) {
            return true;
        }

        if (expression.operator === ComparisonOperator.NotEmpty && value && value.length > 0) {
            return true;
        }

        return false;
    }
}

export class FileUploaderField extends Field {
    placeholder: string;

    maxNumberOfFiles: number = 1;

    fileTypes: string[] = ALLOWED_TYPES;

    constructor(type: FieldType) {
        super(type);
    }

    toJson() {
        const definition = super.toJson();
        assign(definition, {
            placeholder: this.placeholder,
            maxNumberOfFiles: this.maxNumberOfFiles,
            fileTypes: this.fileTypes,
        });
        return definition;
    }
}

export class FileUploaderPickerBuilder extends ComparatorPickerBuilder {
    build(comparisonExpression: ComparisonExpression): ComparatorPicker {
        return new ComparatorPicker(ComparatorPickerType.None);
    }
}
